import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Modal from '@components/common/Modal';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import { getObjectValue } from '@utility/utills';
import cn from 'classnames';
import { TouchableButton } from '@components/common/Touchable';

const KioskConfirmatioPopUp = (props) => {
  const {
    isOpen, onClose, type,
    data,
  } = props;
  const isSpeedOrder = getObjectValue(() => props.speedOrderStatus);
  const [isLandScape, setIsLandScape] = useState(true)
  
  useEffect(() => {
    const handleResize = () => {
      setIsLandScape(window.innerWidth > window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [])

  return (
    <Modal
      isOpen={isOpen}
      isModalCenter
      style={{ backgroundColor: props?.serverAppTheme?.popUp_bg, borderRadius: "16px", border: props?.serverAppTheme?.popupBorder, boxShadow: props?.serverAppTheme?.popUp_box_shadow, width: '486px', minHeight: '216px',margin:'auto' , padding:'1.5rem'}}
      customClass='h-100 w-100'  customClass2='h-100 w-100'
      noBackground
    >
     <div className="col-12 h-100 justify-content-center align-items-center text-center h-100" style={{ color: props?.serverAppTheme?.primary_text }}>
      <div className="justify-content-center align-items-center text-center">
         <div className={cn(isSpeedOrder && isLandScape ? "col-12 fs_18 fw-700 text-center h-auto" : 'col-12 fs_18 fw-700 text-center h-auto')}>Are You Sure ?</div><br />
        <div className="col-12 p-0 pb-4">
          <div className={cn(isSpeedOrder && isLandScape ? "col-12 pt-2 fs_16 fw-400 text-center" : "col-12 pt-2 fs_16 fw-400 text-center")}>
            {type === 'send all' && data.length > 1 && CUSTOM_MESSAGES().SEND_MULTIPLE_MSG}
            {type === 'delete all' && data.length > 1 && CUSTOM_MESSAGES().DELETE_MULTIPLE_MSG}
            {type === 'send all' && data.length === 1 && CUSTOM_MESSAGES().SEND_SINGLE_MSG}
            {type === 'delete all' && data.length === 1 && CUSTOM_MESSAGES().DELETE_SINGLE_MSG}
            {type === 'delete' && data.length === 1 && CUSTOM_MESSAGES().DELETE_ITEM_CONFIRMATION}
            {type === 'unsentRepeat' && data.length === 1 && CUSTOM_MESSAGES().REPEAT_ITEM}
          </div>
          <div>
            
          </div>
        </div>
        <div className="col-12 d-flex justify-content-center mt-4">
              <TouchableButton className={cn(isSpeedOrder && isLandScape ? "col-6 mr-1 btn44 fs_24 fw-600" : "col-6 mr-1 btn44 fs_24 fw-600")} style={{ backgroundColor: props.serverAppTheme?.OFF_Premise_Btn, border: props.serverAppTheme?.cancleBtn_Border, color: props.serverAppTheme?.cancleBtn_font}} type="button" onClick={() => { onClose('no'); }} rippleEffect={true}>
                {LABEL().NO}
              </TouchableButton>
              <TouchableButton className={cn(isSpeedOrder && isLandScape ? "col-6 ml-1 btn44 btn-ripple fs_24 fw-600" : "col-6 ml-1 btn44 btn-ripple fs_24 fw-600")} style={{backgroundColor: props.serverAppTheme?.secondaryBtn, color: props.serverAppTheme?.btn_font_color}} type="button" onClick={() => { onClose('yes'); }} rippleEffect={true}>
                {LABEL().YES}
              </TouchableButton>
        </div>
      </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = ({
  orders, theme
}) => ({
  speedOrderStatus: orders.speedOrderStatus,
  serverAppTheme: theme.serverAppTheme,
});

export default connect(mapStateToProps)(KioskConfirmatioPopUp);
